import { Link } from 'react-router';

import { getHomepageUrl } from '@cartwhl/common/utils/getHomepageUrl';
import AnimatedLogo from '@cartwhl/ui/atoms/AnimatedLogo';

interface WordmarkProps {
  decorative?: boolean;
  large?: boolean;
}

export default function Wordmark({
  decorative = false,
  large = false,
}: WordmarkProps) {
  const content = (
    <AnimatedLogo
      trigger={large ? 'page-end' : 'interaction'}
      className={large ? 'w-full' : 'w-30 lg:w-46 shrink-0'}
      color="text-green-50"
    />
  );

  if (decorative) {
    return (
      <span aria-hidden="true" className="block w-full">
        {content}
      </span>
    );
  }

  const isOnHomepage =
    typeof window === 'undefined' ||
    getHomepageUrl('/') === `${window.location.origin}/`;

  if (isOnHomepage) {
    return (
      <Link
        to="/"
        className="inline-flex shrink-0 items-center outline-none"
        aria-label="Cartwheel home"
      >
        {content}
      </Link>
    );
  }

  return (
    <a
      href={getHomepageUrl('/')}
      className="inline-flex shrink-0 items-center outline-none"
      aria-label="Cartwheel home"
    >
      {content}
    </a>
  );
}
